{
  "confirmationNumber": "पुष्टि संख्या {number}",
  "dateTimeRange": "{date} {startTime} से {endTime} तक"
}
